import styled from "styled-components"
import { displays } from "@Theme/base/Variables"
import { LinkIconStyled } from "@Theme/common/Link.styled"

export const CardItemStyled = styled(LinkIconStyled)`
  ${displays.flexBase}
  border-radius: 7px;
`
